import axios from "../../../../axios";
import Cookies from "js-cookie";

export const addFunction = async (functionName) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/MasterData/AddFunction", {
    token,
    functionName,
  });
};

export const addGrade = async (gradeName) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/MasterData/AddGrade", {
    token,
    gradeName,
  });
};

export const addZone = async (zoneName) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/MasterData/AddZone", {
    token,
    zoneName,
  });
};

export const addRoleType = async (roleType) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/MasterData/AddRoleType", {
    token,
    roleType,
  });
};

export const addJobCategory = async (jobCategory) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/MasterData/AddJobCategory", {
    token,
    jobCategory,
  });
};

export const addDepartment = async (functionID, departmentName) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/MasterData/AddDepartment", {
    token,
    departmentName,
    functionID,
  });
};

export const addJobLocation = async (zone, jobLocation) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/MasterData/AddLocation", {
    token,
    jobLocation,
    zone,
  });
};

export const addGenderType = async (genderType) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/MasterData/AddGenderType", {
    token,
    genderType,
  });
};